import { Routes, Route, useSearchParams, useNavigate } from "react-router-dom";
import { useQueryClient } from "@tanstack/react-query";
import { toast } from "sonner";
import { useRef } from "react";

import PrivateRoute from "./routes/PrivateRoute";
import AppShell from "./components/Layout";
import AuthPage from "./components/AuthPage";
import Policy from "./components/Policy";
import PwaInstallPrompt from "./components/PwaInstallPrompt";
import { ThemeProvider } from "./ThemeProvider";
import { useEffect, useState } from "react";
import { TooltipProvider } from "./components/ui/tooltip";
import { Toaster } from "./components/ui/sonner";

function CheckoutSuccessHandler() {
  const [searchParams] = useSearchParams();
  const queryClient = useQueryClient();
  const navigate = useNavigate();
  const handled = useRef(false);
  const [showSuccess, setShowSuccess] = useState(false);

  useEffect(() => {
    if (searchParams.get("checkout") !== "success" || handled.current) return;
    handled.current = true;
    setShowSuccess(true);

    (async () => {
      try {
        await Promise.all([
          queryClient.invalidateQueries({ queryKey: ["subscription"] }),
          queryClient.invalidateQueries({ queryKey: ["accounts"] }),
        ]);
        toast.success("Welcome to Task Fusion Pro!");
      } catch {
        toast.error("Something went wrong refreshing your account. Please reload the page.");
      } finally {
        setShowSuccess(false);
        window.history.replaceState(null, "", window.location.pathname || "/");
        navigate("/", { replace: true });
      }
    })();
  }, [searchParams, queryClient, navigate]);

  if (!showSuccess) return null;

  return (
    <div className="fixed inset-0 z-[100] flex items-center justify-center bg-background/80 backdrop-blur-sm">
      <div className="rounded-lg border bg-card px-6 py-4 shadow-lg">
        <p className="font-medium">Upgrade successful!</p>
        <p className="text-sm text-muted-foreground">Refreshing your account...</p>
      </div>
    </div>
  );
}

function App() {
  return (
    <ThemeProvider defaultTheme="dark" storageKey="vite-ui-theme">
      <TooltipProvider delayDuration={200}>
    <CheckoutSuccessHandler />
    <PwaInstallPrompt />
    <Routes>
      <Route path="/login" element={<AuthPage />} />

      <Route element={<PrivateRoute />}>
        <Route path="/" element={<AppShell />}></Route>
      </Route>

      <Route path="/privacy" element={<Policy />} />

      <Route path="*" element={<div>404</div>} />
    </Routes>
      </TooltipProvider>
      <Toaster />
    </ThemeProvider>
  );
}

export default App;
